import { useEffect, useRef, useState } from 'react';
import { NumberInput, Flex, Text } from '@mantine/core';

export const TableLines = ({
  idPrefix,
  min,
  max,
  footerLine,
  headerLine,
  onChangeHeaderFooter
}) => {
  const headerRef = useRef();
  const footerRef = useRef();
  const [footerIndex, setFooterIndex] = useState(0);
  const [headerIndex, setHeaderIndex] = useState(0);

  useEffect(() => {
    setHeaderIndex(headerLine);
    setFooterIndex(footerLine);
  }, [footerLine, headerLine]);

  const onChangeHeaderLine = e => {
    const val = e;

    setHeaderIndex(val);
  };

  const onChangeFooterLine = e => {
    const val = e;

    setFooterIndex(val);
  };

  const onBlurHeader = () => {
    onChangeHeaderFooter(footerIndex, headerIndex);
  };

  const onBlurFooter = () => {
    onChangeHeaderFooter(footerIndex, headerIndex);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      headerRef.current.blur();
      footerRef.current.blur();
    }
  };

  return (
    <Flex id={idPrefix || 'grid-table-header-lines-root'} align="center" gap="12px">
      <LineItem
        idPrefix={`${idPrefix || 'grid-table-header-lines'}-start`}
        label="Start"
        value={headerIndex}
        onChange={onChangeHeaderLine}
        error={!headerIndex || headerIndex >= footerIndex || headerIndex < 1}
        onBlur={onBlurHeader}
        inputRef={headerRef}
        onKeyDown={handleKeyDown}
      />

      <LineItem
        idPrefix={`${idPrefix || 'grid-table-header-lines'}-end`}
        label="End"
        value={footerIndex}
        onChange={onChangeFooterLine}
        error={!footerIndex || footerIndex <= headerIndex || footerIndex > max}
        onBlur={onBlurFooter}
        inputRef={footerRef}
        onKeyDown={handleKeyDown}
      />
    </Flex>
  );
};

const LineItem = ({ idPrefix, label, value, onChange, errorMessage, inputRef, ...props }) => {
  return (
    <Flex id={idPrefix || 'grid-table-header-line'} align="center" gap="6px">
      <Text id={`${idPrefix || 'grid-table-header-line'}-label`} fw={500} fz="12px" lh="16px">
        {label}
      </Text>
      <NumberInput
        id={`${idPrefix || 'grid-table-header-line'}-input`}
        {...props}
        value={value}
        onChange={onChange}
        hideControls
        size="xs"
        w="66px"
        clampBehavior="strict"
        ref={inputRef}
      />
    </Flex>
  );
};
